"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormType = void 0;
/** Standard widget requiring network data */
/** Widgets that do not need network data */
let FormType = exports.FormType = /*#__PURE__*/function (FormType) {
  FormType["TABLE"] = "table";
  FormType["INPUT"] = "input";
  FormType["KANBAN"] = "kanban";
  return FormType;
}({}); // interface HeaderVisibility {
//     Show?: 'Show'
//     Hide?: 'Hide'
//     HideWidgetTitleOnly?: 'Hide widget title only'
//     HideWidgetOptionsOnly?: 'Hide widget options only'
// }